export default __webpack_public_path__ + "static/media/mergeAccountsWarningIcon.8c164ae0.svg";